import {
   MedicalImaging,
   MedicalInformation,
   MedicalInformationQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { VisitMedicalImaging } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, StandardSpinner } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { medicalImagingTranslationKeys } from '../../../../translations';

type MedicalImagingDetailsModalLoaderRenderProps = {
   medicalImaging: MedicalImaging;
};

type MedicalImagingDetailsModalLoaderProps = {
   readonly visitMedicalImaging: VisitMedicalImaging;
   readonly children: (renderProps: MedicalImagingDetailsModalLoaderRenderProps) => JSX.Element;
};

export const MedicalImagingDetailsModalLoader = (props: MedicalImagingDetailsModalLoaderProps): JSX.Element | null => {
   const {
      data: medicalInformation,
      loading: medicalInformationLoading,
      error: medicalInformationError,
   } = useCqrsGet<MedicalInformation>(() => {
      const query = new MedicalInformationQuery();
      query.id = Slot.of(props.visitMedicalImaging.medicalInformationId);
      query.showRemoved = true;
      return query;
   });

   // TODO: DREGAB-18859 blokowanie przycisku linku
   if (medicalInformationLoading) {
      return <StandardSpinner />;
   }

   // TODO: DREGAB-18859 jako <Status /> w modalu
   if (medicalInformationError) {
      dispatchSnackbarNegativeEvent(medicalImagingTranslationKeys.failedToFetchMedicalInformation);
      return null;
   }

   return props.children({
      medicalImaging: {
         medicalInformation: medicalInformation,
         icd9: props.visitMedicalImaging.icd9,
         examinationDate: props.visitMedicalImaging.examinationDate,
      },
   });
};
